import { InfiniteLandingExpertsOrbitCarousel } from './InfiniteLandingExpertsOrbitCarousel.tsx'
import { InfiniteLandingGlowLineBase } from './InfiniteLandingGlowLineBase.tsx'

const INFINITE_TITLE_ASSET = '/images/infinite/circle/infinite_x.svg'

export {
  INFINITE_LANDING_EXPERTS,
  InfiniteLandingExpertOrbitItem,
  getCoverflowStyle,
  getRelativeOffset
} from './InfiniteLandingExpertsOrbitCarousel.tsx'

export const InfiniteLandingTestimonials = () => {
  return (
    <div className='bg-black px-7 pt-14'>
      <h2 className='text-center font-libre-caslon text-[24px] tracking-[-0.72px] text-white'>The Infinite Circle</h2>
      <p className='text-center font-libre-franklin text-[12px] font-normal text-[#97ABC2]'>
        A wealth experience designed around you.
      </p>
      <div className='mt-8 flex justify-center'>
        <div className='h-[38.892px] w-[320px] overflow-hidden'>
          <InfiniteLandingGlowLineBase />
        </div>
      </div>
      <div className='mt-8 text-center font-libre-franklin text-[12px] leading-[1.3] tracking-[0.12px] text-white'>
        <p className='font-semibold'>A dedicated team that continuously</p>
        <p className='font-light'>manages, monitors, and executes for you.</p>
      </div>
      <InfiniteLandingExpertsOrbitCarousel />
      <div className='relative mt-[90px] h-[74px] rounded-[20px] bg-gradient-to-b from-[#333F4C] from-[5.091%] to-black to-[84.102%]'>
        <div className='absolute left-1/2 top-[-9px] flex h-[24px] w-[92px] -translate-x-1/2 items-center justify-center rounded-full border border-white/[0.08] bg-gradient-to-b from-[#343d47] from-[2%] via-[#1c232b] to-[#0f1419] to-[98%] shadow-[inset_0_1px_0_rgba(255,255,255,0.14)]'>
          <span className='font-libre-franklin text-[10px] font-medium leading-none tracking-[0.02em] text-[#c8d0d9]'>
            Coming Soon
          </span>
        </div>
        <img src={INFINITE_TITLE_ASSET} alt='Infinite' className='absolute left-1/2 top-[22px] h-[14.55px] w-[67px] -translate-x-1/2' />
        <p className='absolute left-1/2 top-[43px] w-[210px] -translate-x-1/2 text-center font-libre-franklin text-[12px] font-normal leading-[1.3] tracking-[0.12px] text-[#97ABC2]'>
          Your personal AI wealth assistant.
        </p>
      </div>
    </div>
  )
}
